import { FC } from "react";
import { Box, VStack, Heading, Text, Button, Code } from "@chakra-ui/react";

interface CodeSnippetIntegrationProps {
  content: {
    name: string;
    description: string;
    code: string;
    ctaText: string;
  };
}

export const CodeSnippetIntegration: FC<CodeSnippetIntegrationProps> = ({
  content,
}) => {
  const handleGetCode = () => {
    const ctaSection = document.querySelector('[data-section="cta"]');
    if (ctaSection) {
      ctaSection.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <Box
      p="8"
      bg="white"
      borderRadius="xl"
      borderWidth="2px"
      borderColor="gray.200"
      boxShadow="sm"
      display="flex"
      flexDirection="column"
      height="full"
    >
      <VStack align="stretch" spacing="4" flex="1">
        {/* Heading */}
        <Heading
          as="h3"
          fontSize="2xl"
          fontWeight="semibold"
          color="gray.900"
          textAlign="center"
        >
          {content.name}
        </Heading>

        {/* Description */}
        <Text
          fontSize="md"
          color="gray.600"
          textAlign="center"
          lineHeight="tall"
        >
          {content.description}
        </Text>

        {/* Code Block */}
        <Box
          bg="gray.900"
          borderRadius="md"
          p="4"
          position="relative"
          flex="1"
          display="flex"
          alignItems="center"
          userSelect="none"
          pointerEvents="none"
        >
          <Code
            colorScheme="gray"
            bg="transparent"
            color="green.300"
            fontSize="sm"
            fontFamily="mono"
            whiteSpace="pre-wrap"
            wordBreak="break-all"
            width="full"
          >
            {content.code}
          </Code>
        </Box>

        {/* Get Code Button */}
        <Button
          colorScheme="blue"
          size="lg"
          width="full"
          onClick={handleGetCode}
        >
          {content.ctaText}
        </Button>
      </VStack>
    </Box>
  );
};
